'use client';

import { ArrowRight } from 'lucide-react';
import Link from 'next/link';
import Image from 'next/image';

export default function FooterSection() {
    return (
        <div className='px-4 py-6 md:px-8 md:py-12'>
            <footer className="rounded-3xl md:rounded-[2.5rem] bg-foreground text-white py-8 md:py-20 relative overflow-hidden">

                <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">

                    {/* Main Content */}
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-24 mb-8 md:mb-24">

                        {/* Brand & Newsletter (Col 5) */}
                        <div className="lg:col-span-5 flex flex-col gap-6 md:gap-10">
                            <div className="flex flex-col gap-4">
                                <div className="relative w-40 h-16 md:w-56 md:h-20">
                                    <Image
                                        src="/image/logo.webp"
                                        alt="HOPO HOMES"
                                        title="HOPO HOMES"
                                        fill
                                        className="object-contain object-left"
                                    />
                                </div>
                                <p className="text-zinc-300 text-base md:text-lg leading-relaxed max-w-md font-light">
                                    The World's First Fully AI-Managed Rental Ecosystem for short term rentals.  Experience the future of flexible living with three dedicated AI Agents & an impeccable human team to make sure tenants have a seamless living & owners have a smart investment yielding high rental ROI.
                                </p>
                                <div className="flex flex-col gap-1 text-zinc-300 text-sm md:text-base font-light">
                                    <p>In5 Media, Dubai Production city,</p>
                                    <p>Dubai, UAE</p>
                                    {/* <p className="mt-2">+971 4 597 3415</p> */}
                                    <p>info@hopohomes.com</p>
                                </div>
                            </div>

                            {/* Minimalist Newsletter */}
                            {/* <div className="flex flex-col gap-6 mt-0 md:mt-2">
                                <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-400">Newsletter</h4>
                                <div className="flex gap-4 items-center border-b border-zinc-800 pb-3 md:pb-4 focus-within:border-white transition-colors duration-500 group max-w-md">
                                    <input
                                        type="email"
                                        placeholder="Enter your email address"
                                        className="bg-transparent border-none outline-none text-white placeholder-zinc-600 grow text-base md:text-lg"
                                    />
                                    <button className="text-zinc-400 group-hover:text-white transition-colors">
                                        <ArrowRight className="w-5 h-5" />
                                    </button>
                                </div>
                            </div> */}
                        </div>

                        {/* Navigation Links (Col 7) */}
                        <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-6 sm:gap-12 lg:gap-8">
                            {/* Column 1: For You */}
                            <div className="flex flex-col gap-5 md:gap-6">
                                <p className="font-medium text-white text-base md:text-lg">For You</p>
                                <div className="flex flex-col gap-3 md:gap-4 text-zinc-400 font-light text-sm md:text-base">
                                    <Link title="For Tenants" href="/" className="hover:text-white transition-colors duration-300">For Tenants</Link>
                                    <Link title="For Owners" href="/owner" className="hover:text-white transition-colors duration-300">For Owners</Link>
                                    <Link title="Browse Properties" href="/properties" className="hover:text-white transition-colors duration-300">Browse Properties</Link>
                                </div>
                            </div>

                            {/* Column 2: Company */}
                            <div className="flex flex-col gap-5 md:gap-6">
                                <p className="font-medium text-white text-base md:text-lg">Company</p>
                                <div className="flex flex-col gap-3 md:gap-4 text-zinc-400 font-light text-sm md:text-base">
                                    <Link href="/about-us" title="Learn more about HOPO Homes" className="hover:text-white transition-colors duration-300">
                                        About Us
                                    </Link>

                                    <Link href="/blog" title="HOPO Homes blog" className="hover:text-white transition-colors duration-300">
                                        Blog
                                    </Link>

                                    <Link href="/contact" title="Contact HOPO Homes" className="hover:text-white transition-colors duration-300">
                                        Contact Us
                                    </Link>

                                    <Link href="/refund-policy" title="Our Refund Policy" className="hover:text-white transition-colors duration-300">
                                        Refund Policy
                                    </Link>

                                    <Link href="/terms-and-conditions" title="Our Terms and Conditions" className="hover:text-white transition-colors duration-300">
                                        Terms & Conditions
                                    </Link>

                                    <Link href="/privacy-policy" title="Our Privacy Policy" className="hover:text-white transition-colors duration-300">
                                        Privacy Policy
                                    </Link>

                                    <Link href="/faq" title="Frequently Asked Questions" className="hover:text-white transition-colors duration-300">
                                        FAQ
                                    </Link>

                                    <Link href="/" title="HOPO Homes homepage" className="hover:text-white transition-colors duration-300">
                                        Home
                                    </Link>
                                </div>
                            </div>


                            {/* Column 3: AI Features */}
                            <div className="flex flex-col gap-5 md:gap-6">
                                <p className="font-medium text-white text-base md:text-lg">AI Agents</p>
                                <div className="flex flex-col gap-3 md:gap-4 text-zinc-400 font-light text-sm md:text-base">
                                    <div className="flex items-center gap-2 group">
                                        <span className="w-2 h-2 rounded-full bg-emerald-500"></span>
                                        <span className="group-hover:text-white transition-colors">Sales Agent</span>
                                    </div>
                                    <div className="flex items-center gap-2 group">
                                        <span className="w-2 h-2 rounded-full bg-amber-500"></span>
                                        <span className="group-hover:text-white transition-colors">Maintenance Agent</span>
                                    </div>
                                    <div className="flex items-center gap-2 group">
                                        <span className="w-2 h-2 rounded-full bg-blue-500"></span>
                                        <span className="group-hover:text-white transition-colors">Management Agent</span>
                                    </div>
                                    <div className="flex items-center gap-2 group">
                                        <span className="w-2 h-2 rounded-full bg-purple-500 animate-pulse"></span>
                                        <span className="group-hover:text-white transition-colors">24/7 AI Support</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Footer Bottom */}
                    <div className="border-t border-white/5 md:border-none pt-6 md:pt-10 flex flex-col md:flex-row justify-between items-center gap-6 relative z-10">

                        <p className="text-zinc-400 text-sm">© {new Date().getFullYear()} HOPO Homes. All rights reserved.
                            <br></br>
                            SEO by <Link rel="nofollow noopener noreferrer" href="https://www.seotechexperts.ae/real-estate-marketing" target="_blank" className="hover:text-white transition-colors">STE</Link>
                        </p>


                        <div className="flex items-center gap-6 md:gap-8">
                            {/* Instagram */}
                            <Link rel="nofollow noopener noreferrer" title="HOPO Homes on Instagram" aria-label="HOPO Homes on Instagram" href="https://www.instagram.com/hopohomes/" target="_blank" className="text-zinc-400 hover:text-white transition-colors duration-300">
                                <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                                    <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
                                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                                    <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
                                </svg>
                            </Link>
                            {/* X / Twitter */}
                            <Link rel="nofollow noopener noreferrer" aria-label="HOPO Homes on X" title="HOPO Homes on X" href="https://x.com/hopohomes?lang=en" target="_blank" className="text-zinc-400 hover:text-white transition-colors duration-300">
                                <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="w-4 h-4" viewBox="0 0 16 16">
                                    <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
                                </svg>
                            </Link>
                            {/* LinkedIn */}
                            <Link rel="nofollow noopener noreferrer" aria-label="HOPO Homes on LinkedIn" title="HOPO Homes on LinkedIn" href="https://www.linkedin.com/company/hopo-homes/" target="_blank" className="text-zinc-400 hover:text-white transition-colors duration-300">
                                <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                                    <rect width="4" height="12" x="2" y="9" />
                                    <circle cx="4" cy="4" r="2" />
                                </svg>
                            </Link>
                            {/* Facebook */}
                            <Link rel="nofollow noopener noreferrer" aria-label="HOPO Homes on Facebook" title="HOPO Homes on Facebook" href="https://www.facebook.com/hopohomes/" target="_blank" className="text-zinc-400 hover:text-white transition-colors duration-300">
                                <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                                </svg>
                            </Link>
                        </div>
                    </div>

                </div>
            </footer>
        </div>
    );
}
